import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import Input from '@material-ui/core/Input'
import './Dropdown.css'

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}))

export default function SimpleSelect(props) {
    const classes = useStyles()

    return (
        <div>
            <FormControl className={`${classes.formControl} dropDown w-100 text-left m-0`}>
                <InputLabel id="demo-simple-select-label">{props.label}</InputLabel>
                <Select
                    value={props.selected || props.value}
                    onChange={props.onChange}
                    className={classes.selectEmpty}
                    name={props.name}
                    inputProps={{ 'aria-label': 'Without label' }}
                    autoComplete={props.autoComplete || 'on'}
                >
                    {props.dropCountr
                        ? props.dropCountr.map((data, index) => (
                              <MenuItem
                                  onClick={() => {
                                      props.countryID(data.id)
                                      props.ctrcode(data.phoneCode)
                                  }}
                                  value={data.name}
                              >
                                  {data.name}
                              </MenuItem>
                          ))
                        : ''}
                </Select>
            </FormControl>
        </div>
    )
}
